import React, { useEffect, useState } from 'react';
import Slider from 'rsuite/Slider';
import { Heart } from '../forms/input';
const Artist = props => {
  const [isPlayed, setIsPlayed] = useState(false);
  const [audio, setAudio] = useState();
  const [value, setValue] = useState(0);
  const [checked, setChecked] = useState(props.checked);
  const [clicked, setCliced] = useState(false);
  useEffect(() => {
    if (audio) {
      audio.currentTime = 0;
    }
  }, []);
  useEffect(() => {
    if (audio) {
      audio.volume = 0.5;
      audio.ontimeupdate = function () {
        setValue(audio.currentTime);
        if (audio.currentTime >= audio.duration) {
          setIsPlayed(false);
          audio.currentTime = 0;
          audio.autoPlay = true;
          setCliced(false);
          audio.pause();
        }
      };
      // audio.addEventListener('ended', false, false);-
      return () => {
        audio.pause();
        setIsPlayed(false);
        props.setPlayedId('');
        audio.autoPlay = true;
        audio.currentTime = 0;
      };
    }
  }, [audio]);
  useEffect(() => {
    if (props.checked != checked) setChecked(props.checked);
    return () => {
      if (audio) {
        audio.pause();
        setIsPlayed(false);
        audio.autoPlay = true;
        setCliced(false);
      }
    };
  }, [props.checked]);
  useEffect(() => {
    if (clicked) {
      if (props.played) {
        if (isPlayed) {
          setIsPlayed(false);
          audio.pause();
        } else {
          audio.autoPlay = true;
          audio.play();
          setIsPlayed(true);
        }
      } else {
        setIsPlayed(false);
        audio.pause();
      }
    }
  }, [props.played]);
  // useEffect(()=>{
  //      setAudio(new Audio("https://admin.weprodigi.com/" + props.data.attached_sound))
  // },[props.data.attached_sound])
  const showNotify = e => {
    let left = event.clientX - event.target.offsetLeft;
    let top = event.clientY - event.target.offsetTop;
    props.check(props.data.id, props.from);
  };
  const playPause = pause => {
    if (!audio) {
      setAudio(new Audio('https://admin.weprodigi.com/' + props.data.attached_sound));
    }
    if (pause) props.setPlayedId('');
    setCliced(true);
    if (!props.played) {
      props.setPlayedId(props.from + '_' + props.data.id);
    } else {
      props.setPlayedId('');
    }
  };
  return (
    <>
      <style>{`
                .slide-in-blurred-bottom {
                -webkit-animation: .6s cubic-bezier(.23, 1, .32, 1) both slide-in-blurred-bottom;
                animation: .6s cubic-bezier(.23, 1, .32, 1) both slide-in-blurred-bottom;
            }
            @-webkit-keyframes slide-in-blurred-bottom {
                0% {
                    -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(.2);
                    transform: translateY(1000px) scaleY(2.5) scaleX(.2);
                    -webkit-transform-origin: 50% 100%;
                    transform-origin: 50% 100%;
                    -webkit-filter: blur(40px);
                    filter: blur(40px);
                    opacity: 0;
                }
                100% {
                    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
                    transform: translateY(0) scaleY(1) scaleX(1);
                    -webkit-transform-origin: 50% 50%;
                    transform-origin: 50% 50%;
                    -webkit-filter: blur(0);
                    filter: blur(0);
                    opacity: 1;
                }
            }
            @keyframes slide-in-blurred-bottom {
                 0% {
                     -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(.2);
                     transform: translateY(1000px) scaleY(2.5) scaleX(.2);
                     -webkit-transform-origin: 50% 100%;
                     transform-origin: 50% 100%;
                     -webkit-filter: blur(40px);
                     filter: blur(40px);
                     opacity: 0;
                 }
                 100% {
                     -webkit-transform: translateY(0) scaleY(1) scaleX(1);
                     transform: translateY(0) scaleY(1) scaleX(1);
                     -webkit-transform-origin: 50% 50%;
                     transform-origin: 50% 50%;
                     -webkit-filter: blur(0);
                     filter: blur(0);
                     opacity: 1;
                 }
             }
                 .open svg {
                    transform: rotate(90deg);
                }
                .flag-tooltip:hover {
                     transform: scale(1.1);
                 }
                 .grayscale {
                        filter: grayscale(100%);
                    }
                    .grayscale .rs-slider-handle, .grayscale img, .grayscale svg {
                        filter: blur(1px);
                    }
                    
                    
                    
                    
                    
@-webkit-keyframes pump-it-up1 {
    40% {
        height: 25px;
    }
    60% {
        height: 45px;
    }
    80% {
        height: 12px;
    }
    100% {
        height: 5px;
    }
}
@-moz-keyframes pump-it-up1 {
     40% {
         height: 23px;
     }
     60% {
         height: 5px;
     }
     80% {
         height: 37px;
     }
     100% {
         height: 44px;
     }
 }
@-o-keyframes pump-it-up1 {
      40% {
          height: 44px;
      }
      60% {
          height: 26px;
      }
      80% {
          height: 38px;
      }
      100% {
          height: 30px;
      }
  }
@keyframes pump-it-up1 {
       40% {
           height: 24px;
       }
       100%, 60% {
           height: 17px;
       }
       80% {
           height: 3px;
       }
   }
@-webkit-keyframes pump-it-up2 {
        40% {
            height: 24px;
        }
        60% {
            height: 21px;
        }
        80% {
            height: 17px;
        }
        100% {
            height: 11px;
        }
    }
@-moz-keyframes pump-it-up2 {
         40% {
             height: 6px;
         }
         60% {
             height: 49px;
         }
         80% {
             height: 12px;
         }
         100% {
             height: 20px;
         }
     }
@-o-keyframes pump-it-up2 {
          40% {
              height: 46px;
          }
          60% {
              height: 8px;
          }
          80% {
              height: 26px;
          }
          100% {
              height: 48px;
          }
      }
@keyframes pump-it-up2 {
           100%, 40% {
               height: 20px;
           }
           60% {
               height: 38px;
           }
           80% {
               height: 42px;
           }
       }
@-webkit-keyframes pump-it-up3 {
            40% {
                height: 27px;
            }
            60% {
                height: 34px;
            }
            80% {
                height: 18px;
            }
            100% {
                height: 30px;
            }
        }
@-moz-keyframes pump-it-up3 {
             40% {
                 height: 43px;
             }
             60% {
                 height: 20px;
             }
             80% {
                 height: 8px;
             }
             100% {
                 height: 47px;
             }
         }
@-o-keyframes pump-it-up3 {
              40% {
                  height: 2px;
              }
              60% {
                  height: 4px;
              }
              80% {
                  height: 30px;
              }
              100% {
                  height: 5px;
              }
          }
@keyframes pump-it-up3 {
               40% {
                   height: 27px;
               }
               60% {
                   height: 28px;
               }
               80% {
                   height: 44px;
               }
               100% {
                   height: 3px;
               }
           }
@-webkit-keyframes pump-it-up4 {
                40% {
                    height: 27px;
                }
                60% {
                    height: 36px;
                }
                80% {
                    height: 50px;
                }
                100% {
                    height: 14px;
                }
            }
@-moz-keyframes pump-it-up4 {
                 100%, 40% {
                     height: 15px;
                 }
                 60% {
                     height: 41px;
                 }
                 80% {
                     height: 21px;
                 }
             }
@-o-keyframes pump-it-up4 {
                  40% {
                      height: 36px;
                  }
                  60% {
                      height: 6px;
                  }
                  80% {
                      height: 44px;
                  }
                  100% {
                      height: 1px;
                  }
              }
@keyframes pump-it-up4 {
                   40% {
                       height: 10px;
                   }
                   60% {
                       height: 39px;
                   }
                   80% {
                       height: 32px;
                   }
                   100% {
                       height: 35px;
                   }
               }
@-webkit-keyframes pump-it-up5 {
                    40% {
                        height: 16px;
                    }
                    60% {
                        height: 19px;
                    }
                    80% {
                        height: 5px;
                    }
                    100% {
                        height: 21px;
                    }
                }
@-moz-keyframes pump-it-up5 {
                     40% {
                         height: 40px;
                     }
                     60% {
                         height: 34px;
                     }
                     80% {
                         height: 13px;
                     }
                     100% {
                         height: 47px;
                     }
                 }
@-o-keyframes pump-it-up5 {
                      40% {
                          height: 2px;
                      }
                      60% {
                          height: 5px;
                      }
                      80% {
                          height: 7px;
                      }
                      100% {
                          height: 41px;
                      }
                  }
@keyframes pump-it-up5 {
                       40% {
                           height: 39px;
                       }
                       60% {
                           height: 44px;
                       }
                       80% {
                           height: 34px;
                       }
                       100% {
                           height: 30px;
                       }
                   }
@-webkit-keyframes pump-it-up6 {
                        40% {
                            height: 29px;
                        }
                        100%, 60% {
                            height: 26px;
                        }
                        80% {
                            height: 12px;
                        }
                    }
@-moz-keyframes pump-it-up6 {
                         40% {
                             height: 33px;
                         }
                         60% {
                             height: 45px;
                         }
                         80% {
                             height: 34px;
                         }
                         100% {
                             height: 22px;
                         }
                     }
@-o-keyframes pump-it-up6 {
                          40% {
                              height: 38px;
                          }
                          60% {
                              height: 29px;
                          }
                          80% {
                              height: 1px;
                          }
                          100% {
                              height: 50px;
                          }
                      }
@keyframes pump-it-up6 {
                           40% {
                               height: 50px;
                           }
                           60% {
                               height: 9px;
                           }
                           80% {
                               height: 12px;
                           }
                           100% {
                               height: 3px;
                           }
                       }
@-webkit-keyframes pump-it-up7 {
                            40% {
                                height: 2px;
                            }
                            60% {
                                height: 5px;
                            }
                            80% {
                                height: 37px;
                            }
                            100% {
                                height: 45px;
                            }
                        }
@-moz-keyframes pump-it-up7 {
                             40% {
                                 height: 36px;
                             }
                             60% {
                                 height: 18px;
                             }
                             80% {
                                 height: 19px;
                             }
                             100% {
                                 height: 27px;
                             }
                         }
@-o-keyframes pump-it-up7 {
                              100%, 40% {
                                  height: 19px;
                              }
                              60% {
                                  height: 3px;
                              }
                              80% {
                                  height: 36px;
                              }
                          }
@keyframes pump-it-up7 {
                               100%, 40% {
                                   height: 18px;
                               }
                               60% {
                                   height: 10px;
                               }
                               80% {
                                   height: 17px;
                               }
                           }
@-webkit-keyframes pump-it-up8 {
                                100%, 40% {
                                    height: 13px;
                                }
                                60% {
                                    height: 31px;
                                }
                                80% {
                                    height: 5px;
                                }
                            }
@-moz-keyframes pump-it-up8 {
                                 40% {
                                     height: 46px;
                                 }
                                 60% {
                                     height: 39px;
                                 }
                                 80% {
                                     height: 49px;
                                 }
                                 100% {
                                     height: 43px;
                                 }
                             }
@-o-keyframes pump-it-up8 {
                                  40% {
                                      height: 6px;
                                  }
                                  60% {
                                      height: 13px;
                                  }
                                  80% {
                                      height: 36px;
                                  }
                                  100% {
                                      height: 43px;
                                  }
                              }
@keyframes pump-it-up8 {
                                   40% {
                                       height: 50px;
                                   }
                                   60% {
                                       height: 31px;
                                   }
                                   80% {
                                       height: 49px;
                                   }
                                   100% {
                                       height: 29px;
                                   }
                               }
@-webkit-keyframes pump-it-up9 {
                                    40% {
                                        height: 44px;
                                    }
                                    60% {
                                        height: 15px;
                                    }
                                    80% {
                                        height: 48px;
                                    }
                                    100% {
                                        height: 14px;
                                    }
                                }
@-moz-keyframes pump-it-up9 {
                                     40% {
                                         height: 47px;
                                     }
                                     60%, 80% {
                                         height: 43px;
                                     }
                                     100% {
                                         height: 30px;
                                     }
                                 }
@-o-keyframes pump-it-up9 {
                                      40% {
                                          height: 11px;
                                      }
                                      60% {
                                          height: 7px;
                                      }
                                      80% {
                                          height: 46px;
                                      }
                                      100% {
                                          height: 19px;
                                      }
                                  }
@keyframes pump-it-up9 {
                                       40% {
                                           height: 21px;
                                       }
                                       60% {
                                           height: 23px;
                                       }
                                       80% {
                                           height: 41px;
                                       }
                                       100% {
                                           height: 19px;
                                       }
                                   }
#levels {
                                        margin: 0 auto;
                                        width: 254px;
                                        border-radius: 5px;
                                        height: 80px;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    }
#levels .level {
    width: 2px;
    height: 50px;
    margin-left: 1px;
}
#levels .level:after {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 0;
    background: #c4c4c4;
    width: 2px;
}
#levels .level.level1:after {
    height: 14px;
}
#levels .level.level2:after {
    height: 19px;
}
#levels .level.level3:after {
    height: 25px;
}
#levels .level.level4:after {
    height: 16px;
}
#levels .level.level5:after, #levels .level.level8:after {
    height: 24px;
}
#levels .level.level6:after {
    height: 18px;
}
#levels .level.level7:after {
    height: 8px;
}
#levels .level.level9:after {
    height: 13px;
}
.anim .level.level1:after {
    animation: 595ms linear infinite alternate pump-it-up1;
}
.anim .level.level2:after {
    animation: 368ms linear infinite alternate pump-it-up2;
}
.anim .level.level3:after {
    animation: 349ms linear infinite alternate pump-it-up3;
}
.anim .level.level4:after {
    animation: 740ms linear infinite alternate pump-it-up4;
}
.anim .level.level5:after {
    animation: 644ms linear infinite alternate pump-it-up5;
}
.anim .level.level6:after {
    animation: 631ms linear infinite alternate pump-it-up6;
}
.anim .level.level7:after {
    animation: 735ms linear infinite alternate pump-it-up7;
}
.anim .level.level8:after {
    animation: 748ms linear infinite alternate pump-it-up8;
}
.anim .level.level9:after {
    animation: 529ms linear infinite alternate pump-it-up9;
}
.rs-slider-progress-bar {
    position: absolute;
    border-radius: 3px 0 0 3px;
    background-color: #670f7a;
    height: 4px;
    width: 0;
}
.rs-slider-handle:before {
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: -6px;
    cursor: pointer;
    -webkit-transition: background-color .3s ease-in-out, -webkit-box-shadow .3s ease-in-out, -webkit-transform .3s ease-in-out;
    transition: box-shadow .3s ease-in-out, background-color .3s ease-in-out, transform .3s ease-in-out, -webkit-box-shadow .3s ease-in-out, -webkit-transform .3s ease-in-out;
    background-color: #670f7a;
    border: 2px solid #670f7a;
}
.rs-slider-handle:focus:before, .rs-slider-handle:hover:before {
    box-shadow: 0 0 8px #670f7a;
}
            `}</style>
      {props.disabled && props.from != 'check' && (
        <div
          className={
            props.className +
            ' relative w-full ml-10  mr-10 md:mr-20 grayscale ' +
            (props.from == 'check' ? 'md:w-full slide-in-blurred-left' : 'md:w-auto') +
            (props.disabled && props.from != 'check' ? ' ' : ' ')
          }
        >
          {props.from == 'check' && <span className={'text-18 font-bold text-black'}>Option {props.ind}</span>}
          <hr />
          <div className={`rounded-5 pt-10  pb-20 bg-gray mt-15`}>
            {props.from != 'check' && (
              <div id="levels" className={`${isPlayed ? 'anim' : ''}`}>
                <div className="level level1" />
                <div className="level level2" />
                <div className="level level3" />
                <div className="level level4" />
                <div className="level level5" />
                <div className="level level6" />
                <div className="level level7" />
                <div className="level level8" />
                <div className="level level9" />
                <div className="level level5" />
                <div className="level level7" />
              </div>
            )}
            <div className={`audio flex flex-col justify-center items-center px-10 ${props.from == 'check' ? 'pt-15' : 'pt-10'}`}>
              {/*{props.from != 'check' &&*/}
              <div className={'w-full'}>
                <Slider
                  progress
                  tooltip={false}
                  value={value}
                  defaultValue={0}
                  max={audio?.duration}
                  onChange={val => {
                    // setValue(val)
                    // if (val) audio.currentTime = val
                    // else audio.currentTime = 0
                    // if (isPlayed) audio.play()
                  }}
                />
              </div>
              {/*}*/}
              <div className={'w-full flex justify-center mt-20'}>
                <img src="https://admin.weprodigi.com/uploads/images/voiceover/prev.svg" width={20} alt="prev" className={'cursor-pointer'} />
                {isPlayed && (
                  <img
                    src="https://admin.weprodigi.com/uploads/images/voiceover/pause.svg"
                    width={15}
                    alt="pause"
                    className={'cursor-pointer mr-10 ml-10'}
                  />
                )}
                {!isPlayed && (
                  <img
                    src="https://admin.weprodigi.com/uploads/images/voiceover/play.svg"
                    width={20}
                    alt=""
                    className={'cursor-pointer mr-10 ml-10'}
                  />
                )}
                <img src="https://admin.weprodigi.com/uploads/images/voiceover/next.svg" width={20} alt="next" className={'cursor-pointer'} />
              </div>
            </div>
          </div>
          <div className="mt-10 flex justify-between items-end">
            <div className={'w-full'}>
              <h2
                className={`text-green font-bolder ${props.from == 'check' ? 'text-14' : 'text-18'}  flex justify-between w-full items-center mb-10`}
              >
                <div className={'flex items-center'}>
                  <p className={'mr-15 break-words max-w-120'}>{props.data.display_name}</p>
                  <div className={'relative'}>
                    {props.data.accent?.accent_image && (
                      <img
                        className={'ml-10 cursor-pointer flag-tooltip'}
                        src={'https://admin.weprodigi.com/' + props.data.accent?.accent_image}
                        width={25}
                        alt=""
                      />
                    )}
                    <div className={'absolute z-1000 py-2 text-9  text-white for-tooltip  bg-blackD px-10'}>{props.data.accent?.accent_name}</div>
                  </div>
                </div>
                <div className={''}>
                  <Heart
                    from={props.from}
                    checked={props.from == 'check' ? true : checked}
                    name="age"
                    value={props.data.id}
                    id={props.data.id}
                    onChange={e => {
                      showNotify(e);
                    }}
                  />
                </div>
              </h2>
              {/*<p className={""}><span className={"text-15"}>Gender: </span>{props.data.gender == 1 ? "Male" : (props.data.gender == 2 ? "Female" : 'Other')}</p>*/}
              {/*<p className={""}><span className={"text-15"}>Language: </span>{props.data.language.name}</p>*/}
            </div>
          </div>
        </div>
      )}
      {!props.disabled && (
        <div
          className={
            props.className +
            ' relative w-full ml-10 mr-10 md:mr-10 ' +
            (props.from == 'check' ? `md:w-full ${props.landing == 'new' ? '' : ' slide-in-blurred-left '} ` : 'md:w-auto') +
            (props.disabled && props.from != 'check' ? ' ' : ' ')
          }
        >
          {props.from == 'check' && <span className={'text-18 font-bold text-black'}>Option {props.ind}</span>}
          <hr />
          <div className={`rounded-5 pt-10  pb-20 bg-gray mt-15`}>
            {props.from != 'check' && (
              <div id="levels" className={`${isPlayed ? 'anim' : ''}`}>
                <div className="level level1" />
                <div className="level level2" />
                <div className="level level3" />
                <div className="level level4" />
                <div className="level level5" />
                <div className="level level6" />
                <div className="level level7" />
                <div className="level level8" />
                <div className="level level9" />
                <div className="level level5" />
                <div className="level level7" />
              </div>
            )}
            <div className={`audio flex flex-col justify-center items-center px-10 ${props.from == 'check' ? 'pt-15' : 'pt-10'}`}>
              {/*{props.from != 'check' &&*/}
              <div className={'w-full'}>
                <Slider
                  progress
                  tooltip={false}
                  value={value}
                  defaultValue={0}
                  max={audio?.duration}
                  onChange={val => {
                    setValue(val);
                    if (val) audio.currentTime = val;
                    else audio.currentTime = 0;
                    if (isPlayed) audio.play();
                  }}
                />
              </div>
              {/*}*/}
              <div className={'w-full flex justify-center mt-20'}>
                <img
                  src="https://admin.weprodigi.com/uploads/images/voiceover/prev.svg"
                  width={20}
                  alt=""
                  onClick={() => {
                    audio ? (audio.currentTime -= 1) : audio;
                  }}
                  className={'cursor-pointer'}
                />
                {isPlayed && (
                  <img
                    src="https://admin.weprodigi.com/uploads/images/voiceover/pause.svg"
                    width={15}
                    alt=""
                    onClick={playPause}
                    className={'cursor-pointer mr-10 ml-10'}
                  />
                )}
                {!isPlayed && (
                  <img
                    src="https://admin.weprodigi.com/uploads/images/voiceover/play.svg"
                    width={20}
                    alt=""
                    onClick={() => playPause(true)}
                    className={'cursor-pointer mr-10 ml-10'}
                  />
                )}
                <img
                  src="https://admin.weprodigi.com/uploads/images/voiceover/next.svg"
                  width={20}
                  alt=""
                  onClick={() => {
                    audio ? (audio.currentTime += 1) : audio;
                  }}
                  className={'cursor-pointer'}
                />
              </div>
            </div>
          </div>
          <div className="mt-10 flex justify-between items-end">
            <div className={'w-full'}>
              <div
                className={`text-green font-bolder ${props.from == 'check' ? 'text-14' : 'text-18'}  flex justify-between w-full items-center mb-10`}
              >
                <div className={'flex items-center '}>
                  <p className={'mr-15 break-words max-w-120'}>{props.data.display_name}</p>
                  <div className={'relative'}>
                    <img
                      className={'ml-10 cursor-pointer flag-tooltip'}
                      src={'https://admin.weprodigi.com/' + props.data.accent?.accent_image}
                      width={25}
                      alt=""
                    />
                    <div className={'absolute py-2 text-9 z-1000 text-white for-tooltip bg-blackD px-10'}>{props.data.accent?.accent_name}</div>
                  </div>
                </div>
                <div className={'relative'}>
                  <Heart
                    from={props.from}
                    checked={props.from == 'check' ? true : checked}
                    value={props.data.id}
                    id={props.data.id}
                    onChange={() => {
                      props.check(props.data.id, props.from);
                    }}
                  />
                  {props.showNotification && (
                    <div
                      id={'notify_' + props.from + '_' + props.ind}
                      className={
                        'absolute -top-30 bg-white border-1 border-purple px-20 rounded-5 py-2 z-1000 text-purple font-normal min-w-200 right-0 text-center slide-in-blurred-bottom'
                      }
                    >
                      You can chose only 3 artist
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Artist;
